export const ENABLE_REDUX_DEV_TOOLS = true;

export const THEMES = {
  LIGHT: "LIGHT",
  ONE_DARK: "ONE_DARK",
};

export const UNIT = [
  "ก/ป",
  "กระสอบ",
  "กล.",
  "กล่อง",
  "ก้อน",
  "กิโล",
  "กุรุส",
  "ขด",
  "คู่",
  "ไจ",
  "ชุด",
  "ดอก",
  "ตัว",
  "ถัง",
  "ถุง",
  "ท่อน",
  "แท่ง",
  "ใบ",
  "ปื้น",
  "แผง",
  "แผ่น",
  "ม้วน",
  "เม็ด",
  "เมตร",
  "ลัง",
  "ลูก",
  "เส้น",
  "หลอด",
  "ห่อ",
  "หัว",
  "โหล",
  "โหลคู่",
  "อัน",
];
